import {
  Box,
  Typography,
  RadioGroup,
  FormControlLabel,
  Radio,
  TextField,
  InputAdornment,
  Stack,
} from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "../../../../../hooks/useTranslation";
import { GeneralSettingsFormValues } from "../GeneralSettings";
import { useMarketplaceStore } from "../../../../../store/useMarketplaceStore";

export const CurrencyRateSettings = () => {
  const {
    control,
    register,
    formState: { errors },
  } = useFormContext<GeneralSettingsFormValues>();
  const selectedCountry = useMarketplaceStore((state) => state.selectedCountry);
  const { translate } = useTranslation("pages.stores.settings.generalSettings");
  const { getLocale } = useTranslation();
  const locale = getLocale();
  const getFormattedDate = () => {
    const now = new Date();
    now.setHours(0, 1, 0, 0);

    const options: Intl.DateTimeFormatOptions = {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    };
    return now.toLocaleString(locale, options);
  };

  return (
    <Box display="flex" alignItems="center" mb={2}>
      <Typography variant="body2" fontWeight="bold" sx={{ width: "20%" }}>
        {translate("currencyRate")}:
      </Typography>
      <Controller
        name="currencyRateType"
        control={control}
        render={({ field }) => (
          <Box>
            <Box display="flex" mb={2}>
              <RadioGroup {...field} value={field.value ?? ""}>
                <FormControlLabel
                  value="AUTOMATIC"
                  control={<Radio />}
                  label={translate("automatic")}
                />
                <Stack direction={"row"} alignItems={"center"}>
                  <FormControlLabel
                    value="MANUAL"
                    control={<Radio />}
                    label={translate("manual")}
                  />
                  {field.value === "MANUAL" && (
                    <Box>
                      <Box
                        display="flex"
                        alignItems="center"
                        height="min-content"
                        marginLeft="16px"
                      >
                        <Typography
                          variant="subtitle2"
                          sx={{ marginRight: "8px" }}
                        >
                          {translate("USD")} =
                        </Typography>
                        <TextField
                          variant="outlined"
                          size="small"
                          margin="none"
                          slotProps={{
                            input: {
                              startAdornment: (
                                <InputAdornment position="start">
                                  {selectedCountry?.currency}
                                </InputAdornment>
                              ),
                            },
                          }}
                          error={!!errors["currencyRate"]}
                          helperText={
                            errors["currencyRate"]
                              ? translate("required", {
                                  fieldName: translate("currencyRate"),
                                })
                              : ""
                          }
                          {...register("currencyRate", { required: true })}
                        />
                      </Box>
                    </Box>
                  )}
                </Stack>
              </RadioGroup>
            </Box>
            <Typography variant="subtitle2">
              {translate("currentCurrency")}:
              {` 1 ${translate("USD")} = ${selectedCountry?.rate} ${selectedCountry?.currency}`}
            </Typography>
            <Typography variant="subtitle2">
              {translate("rateUpdateTime")}: {getFormattedDate()}
            </Typography>
          </Box>
        )}
      />
    </Box>
  );
};
